// extracted by mini-css-extract-plugin
module.exports = {"productionTarget":"ProductionTarget_productionTarget__2qfhy"};